<template>
  <el-dialog title="修改头像"
             :visible.sync="visible"
             @open="init"
             @close="doClose"
             :append-to-body="true"
             :destroy-on-close="true"
             :modal-append-to-body="true"
             :close-on-click-modal="false"
             width="600px">
    <el-row type="flex" align="middle">
      <el-col :span="16" style="text-align: center">
        <label class="el-button el-button--primary el-button--small" for="uploads">点击上传</label>
        <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg"
               @change="uploadImg($event, 1)"/>
        <div class="cropper-wrap">
          <VueCropper
              ref="cropper"
              :img="option.img"
              :outputSize="option.size"
              :outputType="option.outputType"
              :info="true"
              :full="option.full"
              :canMove="option.canMove"
              :canMoveBox="option.canMoveBox"
              :fixedBox="option.fixedBox"
              :original="option.original"
              :autoCrop="option.autoCrop"
              :autoCropWidth="option.autoCropWidth"
              :autoCropHeight="option.autoCropHeight"
              :centerBox="option.centerBox"
              :high="option.high"
              :infoTrue="option.infoTrue"
              @realTime="realTime"
              :enlarge="option.enlarge"
          ></VueCropper>
        </div>
      </el-col>
      <el-col :span="8">
        头像预览
        <div class="preview-wrap">
          <div :style="previews.div">
            <img :src="previews.url" :style="previews.img"/>
          </div>
        </div>
      </el-col>
    </el-row>
    <div slot="footer">
      <el-button @click="doClose" size="medium"><i class="fa fa-close"></i> 关闭</el-button>
      <el-button type="primary" @click="saveVia" size="medium"><i class="fa fa-save"></i> 确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {updateAvatar, uploadAvatar} from '@/api/system/user'
import {VueCropper} from "vue-cropper";
import {getUniqueStr} from "@utils/index";
import {mapGetters} from "vuex";

export default {
  name: 'edit-avatar',
  components: {VueCropper},
  props: {
    visible: false
  },
  data() {
    return {
      filename: '',
      previews: {},
      option: {
        img: this.avatar,
        size: 1,
        full: false, //输出原图比例截图 props名full
        outputType: 'jpeg',
        canMove: true, //能否拖动图片
        fixedBox: false, //固定截图框大小 不允许改变，默认：false
        original: false, //上传图片按照原始比例渲染
        canMoveBox: true, //截图框能否拖动
        autoCrop: true, //是否默认生成截图框
        autoCropWidth: 150, //默认生成截图框宽度
        autoCropHeight: 150, //默认生成截图框高度
        centerBox: true, //截图框是否被限制在图片里面
        infoTrue: true, //true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        enlarge: 1, //图片根据截图框输出比例倍数
        high: true //是否按照设备的dpr 输出等比例图片
      },
    }
  },
  computed: {
    ...mapGetters(['user', 'avatar']),
  },
  methods: {
    realTime(data) {
      this.previews = data
    },
    saveVia() {
      if (!this.option.img) {
        this.$message.warning('请选择你需要上传的图片')
        return
      }
      this.$refs.cropper.getCropBlob(data => {
        let param = new FormData()
        param.append('file', data, getUniqueStr() + '.jpg')
        uploadAvatar(param).then(resp => {
          updateAvatar(this.user.id, resp.data.result)
          this.$store.commit('SET_AVATAR', resp.data.result)
          this.$message.success(resp.data.message)
        })
        this.doClose()
      })
    },
    uploadImg(e, num) {
      //上传图片
      let file = e.target.files[0]
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
        return false
      }
      this.filename = file.name
      let reader = new FileReader()
      reader.onload = e => {
        let data
        if (typeof e.target.result === 'object') {
          data = window.URL.createObjectURL(new Blob([e.target.result])) // 把Array Buffer转化为blob 如果是base64不需要
        } else {
          data = e.target.result
        }
        if (num === 1) {
          this.option.img = data
        } else if (num === 2) {
          this.example2.img = data
        }
      }
      // 转化为base64
      // reader.readAsDataURL(file)
      // 转化为blob
      reader.readAsArrayBuffer(file)
    },
    doClose() {
      this.$emit('done', false)
    }
  }
}
</script>

<style lang="scss" scoped>

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar-wrap {
  border: 1px solid #ebebeb;
  border-radius: 50px;
  width: 50px;
  height: 50px;
  margin: 0 auto;
  overflow: hidden;
  text-align: center;
}

.avatar-wrap img {
  max-width: 100%;
  height: auto;
}

.cropper-wrap {
  border: 1px solid #ebebeb;
  width: 300px;
  height: 300px;
  overflow: hidden;
  margin: 0 auto;
}

.preview-wrap {
  border: 1px solid #ebebeb;
  width: 150px;
  height: 150px;
  overflow: hidden;
}
</style>
